import { resetFormAndDispatchChanges } from "./applyFormData";
import { resetCalculatorWithResetParams, restoreCalcActives } from "./calculator";
import { showHideChildrenByNames } from "./changeObjectParams/helpers";

export const resetObjectParams = async () => {
    const formId = "form-object-params";
    resetCalculatorWithResetParams();
    restoreCalcActives();
    await resetFormAndDispatchChanges(formId);
    showHideChildrenByNames(servObj.redactorModeObject, servObj.redactorModeObject.children, true);
    servObj.tableSize.tableWidth.current = servObj.tableSize.tableWidth.default;
    servObj.tableSize.tableDepth.current = servObj.tableSize.tableDepth.default;
};
